import { queryOptions, useQuery } from "@tanstack/react-query";
import { DateTime } from "luxon";
import { neWebApi } from "../../../../api";
import { neWebUrls } from "../../../../ne-web-urls";
import type { PPADeliveryContractsResponse } from "../PPAContractPage.types";

// For simplicity, we fetch only contracts valid "now"
export const PPA_DELIVERY_CONTRACTS_DEFAULT_QUERY_PERIOD = {
  start: DateTime.now().toISODate(),
  end: DateTime.now().plus({ days: 1 }).toISODate()
};

function ppaDeliveryContractsQueryOptions() {
  return queryOptions({
    queryKey: ["ppaDeliveryContracts"],
    queryFn: fetchPPADeliveryContracts
  });
}

async function fetchPPADeliveryContracts() {
  const ppaDeliveryContractsUrl = neWebUrls.api.ppaDirectDeliveryContracts(
    PPA_DELIVERY_CONTRACTS_DEFAULT_QUERY_PERIOD.start,
    PPA_DELIVERY_CONTRACTS_DEFAULT_QUERY_PERIOD.end
  );
  const response = await neWebApi.get<PPADeliveryContractsResponse>(
    ppaDeliveryContractsUrl
  );

  return response.data;
}

export function usePPADirectDeliveryContracts() {
  return useQuery(ppaDeliveryContractsQueryOptions());
}
